import withRouter from "hoc/withRouter";
import { useGetAIAgent } from "hooks/useGetAIAgent";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, CircularProgress, IconButton, TextField, Tooltip } from "@mui/material";
import AgentsService from "services/admin/AgentsService";
import { toast } from "react-toastify";
import _ from "lodash";
import { FaQuestionCircle } from "react-icons/fa";

const AgentPrompts = ({
  router: {
    params: { id },
  },
}: any) => {
  const { data: agent, isLoading, error } = useGetAIAgent(id);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { isValid },
    reset,
  } = useForm({
    defaultValues: {
      prompt: _.get(agent, "prompt", ""),
    },
    mode: "onChange",
  });

  useEffect(() => {
    reset({
      prompt: _.get(agent, "prompt", ""),
    });
  }, [agent]);

  const onSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await AgentsService.put(id, {
        prompt: data.prompt,
      });
      toast.success("Промтинг сохранен успешно!");
    } catch (error) {
      toast.error("Ошибка при сохранении промтинга!");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <h3 className="mb-4">
        Промтинг
        <Tooltip title="Промтинг — это «мозг» агента: он задаёт роль, ограничения, формат ответов, доступные действия (function calling), этикет, язык и примеры. Чем яснее и конкретнее — тем предсказуемее поведение модели.">
          <IconButton>
            <FaQuestionCircle size={14} />
          </IconButton>
        </Tooltip>
      </h3>
      <p className="mb-8 text-sm text-gray-500"></p>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <div className="mb-8">
          <TextField
            required
            multiline
            minRows={15}
            maxRows={18}
            label="Инструкция"
            {...register("prompt", { required: true })}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              width: "100%", // Adjust width as needed
              "& .MuiInputBase-inputMultiline": {
                resize: "vertical", // Enables vertical resizing
              },
            }}
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={!isValid || isSubmitting}
        >
          {isSubmitting ? <CircularProgress size={20} /> : "Сохранить"}
        </Button>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </form>
    </div>
  );
};

export default withRouter(AgentPrompts);
